import APIRequest from '@/api'
import { UserInfo } from '@/api/Models/UserInfo'
import { useAuthStore } from '@/stores/login'
import { useUsersStore } from '@/stores/users'
import { computed } from 'vue'

export const updateUserInfo = async () => {
  const res = await APIRequest.User.getUserInfo()
  const { code, data } = res
  if (code === 1) {
    const authStore = useAuthStore()
    const usersStore = useUsersStore()
    const { setUserId, setTeamStudy, setUserAuth, setDeptId, setWearImageId, setWearImageUrl, setRoleCodes } = authStore
    const { setCollegeId } = usersStore
    setTeamStudy(0)
    setDeptId(data?.deptId as string)
    setRoleCodes(data?.roleCodes || [])
    setUserAuth({
      teamLearningLabel: 0,
      teachingMgtLabel: 0,
      workbenchLabel: 0
    })
    setTeamStudy(data?.sysUserLabel?.teamLearningLabel as number)
    setUserAuth({
      teamLearningLabel: data?.sysUserLabel?.teamLearningLabel as number,
      teachingMgtLabel: data?.sysUserLabel?.teachingMgtLabel as number,
      workbenchLabel: data?.sysUserLabel?.workbenchLabel as number
    })
    setUserId(data.id)
    setCollegeId(data.collegeId)
    setWearImageId(data.wearImageId || '')
    setWearImageUrl(data.wearImageUrl || '')
  }
}

const showCompany = (userInfo: UserInfo): boolean => {
  const list = userInfo.tenantConfigList
  for (let i = 0; i < list.length; i++) {
    if (list[i].code === 'COMPANY_MGMT' && list[i].value === '1') {
      return true
    }
  }
  return false
}

const showLive = (userInfo: UserInfo): boolean => {
  const list = userInfo.tenantConfigList
  for (let i = 0; i < list.length; i++) {
    if (list[i].code === 'LIVE_MODULE' && list[i].value === '1') {
      return true
    }
  }
  return false
}

export const userValidate = async () => {
  const authStore = useAuthStore()
  const { setTeamStudy, setDeptId, setShowCompany, setHasHistoryData } = authStore
  setTeamStudy(0)
  const { code, data } = await APIRequest.User.getUserInfo()
  if (code === 1) {
    setTeamStudy(data?.sysUserLabel?.teamLearningLabel as number)
    setDeptId(data?.deptId as string)
    setShowCompany(showCompany(data))
    setHasHistoryData(showLive(data))
  }
  return { code, data }
}

export const useShowAdminRights = () => {
  const authStore = useAuthStore()
  return computed(() => {
    const codes = authStore.getRoleCodes || []
    return codes.length > 0
  })
}